import { Component, OnInit, ViewChild } from '@angular/core';
import { MainService } from 'src/app/_services/main.service';
import { ActivatedRoute, Router, Event, NavigationStart } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LeagueRegPopupComponent } from './../league-reg-popup/league-reg-popup.component';
import { TournamentService } from './../tournamentpopup/tournament.service';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-tiers',
  templateUrl: './tiers.component.html',
  styleUrls: ['./tiers.component.scss']
})
export class TiersComponent implements OnInit {
  sub_isMobileScreen: Subscription;
  sub_result: Subscription;
  joinLeagueData: any;
  isMobile = false;
  visibleQuickJoin = false;
  quickContests = [];
  parameters = {league_id: null, lgm_id: null};
  user: any = null;
  players = [];
  myTeam = [];
  myTeams = [];
  standings = [];
  currentTier: number | null;
  tiers = [
    {
      label: 'All',
      value: 0,
      max_players: 0,
      remaining: 0
    }
  ];
  mode = 'create'; // or standings
  isMyTeam = true;
  teamName = '';
  activeTab = 1;
  uploadURL = `${environment.assetUploadURL}`+'/players/';
  searchString = '';
  searchTimer = null;
  tierData = null;
  showHeader = false;
  baseURL = `${environment.SITE_URL}`;
  bucketURL = `${environment.assetURL}`+'/assets/default/images/';
  leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  errorMsg = '';
  successMsg = '';
  newTeam = false;
  isLoading = true;
  @ViewChild('leagueHeader') leagueHeader?: any;

  constructor(private spinner: NgxSpinnerService, private router: Router, private tournamentService: TournamentService, private store: Store<any>, public dialog: MatDialog, private _mainService: MainService, private route: ActivatedRoute) {
    this.spinner.show();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
          this.spinner.show();
      }
    });
    this.store.select('authData').subscribe(state => {
      if (localStorage.getItem('currentUser') == null){
        // redirect to login page
        window.location.href = `${environment.SITE_URL}`+ '/logout';
      }
      if(state[0]){
        this.user = state[0];
        this.route.params.subscribe(params => {
          this.parameters.league_id = params.league_id;
          this.parameters.lgm_id = (params.lgm_id != null) ? params.lgm_id : 0;
          if (this.parameters.lgm_id == 0) this.newTeam = true;
          if (this.user != null){
            // if user already populated start service calls
            this.getTeamDetails();
          }
        });
      }
    });
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
  }

  getTeamDetails(){
    this._mainService.getTiersData(this.parameters.league_id, this.user.id, this.parameters.lgm_id).subscribe(state => {
      if (state.status == 1){
        this.isLoading = false;
        this.myTeam = [];
        this.myTeams = [];
        this.players = [];
        this.standings = [];
        this.tiers = [
          {
            label: 'All',
            value: 0,
            max_players: 0,
            remaining: 0
          }
        ];
        this.errorMsg = '';
        this.successMsg = '';
        state.entities.players.sort((a, b) => {
          return a.tier - b.tier || a.prj - b.prj;
        });
        // this.players = state.entities.players.filter(player => player.tier > 0);
        this.myTeam = state.entities.ranked_player;
        this.myTeams = state.entities.myTeams;
        state.entities.tiers.forEach(tier => {
          tier.remaining = 0;
          this.tiers.push(tier);
          this.players = [...this.players,...state.entities.players.filter(player => player.tier == tier.value)];
        });
        if (state.entities.league.egs < Math.floor(Date.now()/1000)){
          this.myTeam.forEach(player => {
            player.fpts = (!isNaN(parseFloat(player.start_time)))?parseFloat(player.start_time):0;
          });
        }
        if (!state.entities.plr_list) this.mode = 'standings';
        // increment remaining values in tiers object
        let inc = 0;
        this.myTeam.forEach(spot => {
          if (spot.id == 0){
            inc++;
            this.tiers[spot.pn].remaining++;
          }
        });
        // set remaining for 'ALL' tier
        this.tiers[0].remaining = inc;
        this.currentTier = 0;
        this.isMyTeam = (state.entities.myteam_id > 0) ? true : false;
        this.teamName = state.entities.team_name;
        this.tierData = state.entities;
        this.standings = state.entities.standing;
        this.showHeader = true;
        this.spinner.hide();
        if (this.myTeams.length >= state.entities.max_entries && this.parameters.lgm_id == 0){
          // redirect to first entry, can't make new team
          this.spinner.show();
          this.newTeam = false;
          this.router.navigateByUrl('/tiers/'+this.parameters.league_id+'/'+this.myTeams[0].id);
          // this.getTeamDetails();
        }
        // this.showQuickJoin();
        // console.log(state.entities);
      }
    });
  }

  filterPlayers = (player: any) => {
    if (this.searchString != ''){
      const regex = new RegExp(this.searchString,'gi');
      return (player.fn.match(regex) != null || player.ln.match(regex) != null);
    } else if ((player.tier == this.currentTier || this.currentTier == 0) && player.is_hide == 0){
      let isValid = false;
      if (this.tiers[player.tier].remaining > 0 && player.tier > 0) isValid = true;
      return isValid;
    } else {
      return false;
    }
  }

  selectPlayer(player){
    for (let i=0;i<this.myTeam.length;i++){
      // find eligible player slot
      const slot = this.myTeam[i];
      if (slot.id == 0 && slot.pn == player.tier){
        // eligible slot
        slot.id = player.id;
        slot.proj = player.prj;
        slot.opp = player.opp;
        slot.pname = player.fn + ' ' + player.ln;
        slot.plrImage = this.uploadURL+player.pp;
        slot.gp_id = player.pid;
        player.is_hide = 1;
        this.tiers[0].remaining--;
        if (this.tiers[0].remaining == 0) this.activeTab = 1;
        this.tiers[player.tier].remaining--;
        if (this.tiers[player.tier].remaining == 0 && this.currentTier > 0){
          for (let j=1;j<this.tiers.length;j++){
            if (this.tiers[j].remaining > 0){
              this.currentTier = this.tiers[j].value;
              break;
            }
          }
        }
        break;
      }
    }
  }

  getLastName(player){
    let temp = player.pname.split(' ');
    temp.splice(0,1);
    return temp.join(' ');
  }

  removePlayer(player,event){
    event.stopPropagation();
    for (let i=0;i<this.players.length;i++){
      if (this.players[i].id == player.id){
        this.players[i].is_hide = 0;
        break;
      }
    }
    player.pname = 'Select player';
    player.id = 0;
    player.opp = 'LAL';
    player.proj = 0;
    player.plrImage = '';
    player.gp_id = 0;
    this.tiers[player.pn].remaining++;
    this.tiers[0].remaining++;
  }

  setSearch(event){
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.searchString = event.target.value;
    },800);
  }

  joinLeaguePopup(league = null, isQuickJoin = false) {
    this.errorMsg = '';
    if (league == null) league = this.tierData.league;
    this.tournamentService.getUserLocation(this.user.id, locationData => {
      locationData['league_code'] = league.league_code;
      locationData['user_id'] = this.user.id;
      this.sub_result = this.tournamentService.getJoinPopUpData(locationData).subscribe(res => {
        if (typeof res !== 'undefined' && res.status === 'success') {
          this.joinLeagueData = res.entities;
          if(this.joinLeagueData && (Number(this.joinLeagueData.balance) < Number(this.joinLeagueData.league_fee)) && (!this.joinLeagueData.hasTicket)){
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': "Deposit", 'body': '','type':'deposit_fee','league_type':league.lg_abbr,'name':league.name,'balance_text':this.joinLeagueData.balance_text,'entry_fee':this.joinLeagueData.entry_fee }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              // if (res) {
              //   console.log(res);
              // }
            })
          }else{
            const remaining_people = Number(league.entrants) - Number(league.joined_entrants);
            this.leagueDialogRef = this.dialog.open(LeagueRegPopupComponent, {
              width: '500px',
              data: { 'league_code': league.league_code, 'draft_type': 'league', 'result':this.joinLeagueData, 'remaining_people':remaining_people, 'drafttype_id':5 }
            });
        
            this.leagueDialogRef.afterClosed()
            .subscribe(res => {
              if (res.status == 'success'){
                if (!isQuickJoin){
                  this.parameters.lgm_id = res.my_team_id;
                  this.sendRoster();
                } else {
                  this.sendRoster(league, res.my_team_id);
                }
              } else {
                this.errorMsg = res.message;
              }
            })
          }
        }
        else {
          this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: (res.type == 'age_18') ? '500px' : '800px',
              data: { 'title': "Eligibility Warning", 'body': res.message,'type':res.type }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              if (res) {
               
              }
            })
        }
      });
    });
  }

  changeTeam(event){
    this.spinner.show();
    if (parseInt(event.value) > 0){
      this.newTeam = false;
      this.router.navigateByUrl('/tiers/'+this.parameters.league_id+'/'+event.value);
    } else {
      this.newTeam = true;
      this.router.navigateByUrl('/tiers/'+this.parameters.league_id);
    }
    // this.getTeamDetails();
  }

  sendRoster(league = null, lgm_id = null){
    this.errorMsg = '';
    if (lgm_id == null) lgm_id = this.parameters.lgm_id;
    if (league == null) league = this.tierData.league;
    if (league.league_id == null) league.league_id = this.parameters.league_id;
    if (league.egs == null) league.egs = parseInt(league.pro_game_start_time);
    if (this.tiers[0].remaining == 0 && this.isMyTeam && lgm_id > 0 && this.mode == 'create' && league.egs > Math.floor(Date.now()/1000)){
      this._mainService.saveTiersRoster(league.league_id,lgm_id,league.game_id,this.myTeam).subscribe(state => {
        if (state.status == 'success'){
          this.successMsg = state.message;
          if (this.newTeam){
            this.showQuickJoin();
          }
          if (league.my_entries != null) league.my_entries++;
          league.joined_entrants = parseInt(league.joined_entrants)+1;
        } else {
          this.errorMsg = state.message;
        }
      });
    } else {
      if (this.parameters.lgm_id == 0) this.errorMsg = 'You haven\'t properly entered the contest yet.';
      if (!this.isMyTeam) this.errorMsg = 'You don\'t own the team you\'re trying to edit.';
      if (this.mode != 'create' || this.tierData.league.egs <= Math.floor(Date.now()/1000)) this.errorMsg = 'The contest has already started.';
      if (this.tiers[0].remaining > 0) this.errorMsg = 'You are trying to submit an incomplete team.';
    }
  }

  openInfo(player, player_id, e) {
    e.preventDefault();
    e.stopPropagation();
    if ((player.infobox == null || player.infobox == 1) && player_id) {
      this.dialog.open(Playerinfobox2Component, {
        width: (this.isMobile) ? '90%' : '70%',
        height: 'auto',
        autoFocus: false,
        data: {
          isDraft: false,
          league: {
            game_id: 5,
            id: this.tierData.fantasy_lg_id,
            abbr: 'pga',
            active_season_id: this.tierData.league.season_id
          },
          lgm_id: 0,
          players: [],
          player_data : {'pp' : player.pic, 'fn' : player.fn, 'ln' : player.ln},
          player_id
        }
      });
    }
  }
  
  ngOnInit() {
    this.spinner.show();
    // this.isLoading =false;
  }

  showQuickJoin(){
    this._mainService.tiersQuickJoin(this.tierData.league.lg_abbr, this.tierData.position_set, this.user.id, 5).subscribe(state => {
      if (state.status == 'success' && state.entities.tournamentList.length){
        state.entities.tournamentList.forEach(contest => {
          contest.my_entries = (contest.league_joined_users != null)?contest.league_joined_users.split(',').filter(user => parseInt(user) == parseInt(this.user.id)).length:0;
          contest.confirm = 0;
        });
        // remove maxed contests from list
        const contests = state.entities.tournamentList.filter(contest => {
          contest.joined_entrants = parseInt(contest.joined_entrants);
          contest.entrants = parseInt(contest.entrants);
          contest.max_entries = parseInt(contest.max_entries);
          const tiers = JSON.parse(contest.tiers);
          let isValid = true;
          // is structure the same?
          for (var i=0;i<tiers.length;i++){
            if (this.tiers[i+1] == null || this.tiers[i+1].max_players != tiers[i]) isValid = false;
          }
          if (tiers.length != this.tiers.length - 1) isValid = false;
          return contest.my_entries < parseInt(contest.max_entries) && isValid;
        });
        // console.log(contests);
        if (contests.length){
          // do something with contests
          this.quickContests = contests;
          this.visibleQuickJoin = true;
        }
      }
    });
  }
  
  getInjuryAbbr(desc) {
    switch (desc) {
      case 'Out':
        return 'O';
      case 'Day-To-Day':
        return 'Q';
      case 'IR':
        return 'O';
      case 'IR-NR':
        return 'O';
      case 'IR-LT':
        return 'O';
      case 'QUESTIONABLE':
        return 'Q';
      case 'DOUBTFUL':
        return 'O';
      case 'OUT':
        return 'O';
      case 'INACTIVE':
        return 'O';
      case 'PUP-R':
        return 'O';
      case 'PUP-P':
        return 'O';
      case 'IR-R':
        return 'O';
      case 'IR':
        return 'O';
      case 'RESERVE-DNR':
        return 'O';
      case 'NFI-R':
        return 'O';
      case 'NFI-A':
        return 'O';
      case 'RESERVE-CEL':
        return 'O';
      case 'RESERVE-SUS':
        return 'O';
      case 'RESERVE-RET':
        return 'O';
      case 'RESERVE-EX':
        return 'O';
      case 'RESERVE-COVID-19':
        return 'O';
      case 'GTD':
        return 'D';
      case 'OUT':
        return 'O';
      case 'OFS':
        return 'O';
      case '60-Day IL':
        return 'O';
      case '15-Day IL':
        return 'O';
      case '10-Day IL':
        return 'O';
      case 'Out':
        return 'O';
      case '7-Day IL':
        return 'O';
      case 'Suspension':
        return 'O';
      case 'Paternity':
        return 'O';
      case 'Bereavement':
        return 'O';
      case 'COVID-19':
        return 'O';
      default:
        return desc.charAt(0);
    }
  }

  quickJoin(contest){
    contest.confirm = (contest.confirm == 0) ? 1 : 0; // 2-step join confirmation
    if (!contest.confirm){
      this.joinLeaguePopup(contest, true);
    }
  }

  redirect(contest){
    this.router.navigateByUrl('/tiers/'+contest.league_id);
    this.visibleQuickJoin = false;
    this.ngOnInit();
    location.reload();
  }
}
